var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 16.8325C7.12212 17.044 6.87128 17.2118 6.59517 17.3263C6.31906 17.4409 6.02309 17.4999 5.72417 17.5H2.5V14.2966C2.5 13.6933 2.74 13.1141 3.16667 12.6875M7.33333 16.8325L3.16667 12.6875M7.33333 16.8325L15.645 8.51746M3.16667 12.6875L11.4867 4.3583M15.645 8.51746L16.8358 7.32746C17.2629 6.90035 17.5029 6.32107 17.5029 5.71705C17.5029 5.11302 17.2629 4.53374 16.8358 4.10663L15.8975 3.16746C15.6859 2.95579 15.4347 2.78789 15.1582 2.67336C14.8817 2.55883 14.5854 2.49992 14.2861 2.5C13.9868 2.50008 13.6905 2.55914 13.414 2.67381C13.1376 2.78848 12.8865 2.95651 12.675 3.1683L11.4867 4.3583M15.645 8.51746L11.4867 4.3583",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.05d34898a744ffbe8b8ae6bde5bd6733.svg";
export { ForwardRef as ReactComponent };